import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      toastMixin_toasts: []
    }
  },
  created () {
    this.toastMixin_toasts = this.toasts
  },
  computed: {
    ...mapGetters(['toasts']),
    toastMixin_activeToasts () {
      return this.toastMixin_toasts.filter(toast => toast.active === true)
    }
  },
  watch: {
    '$store.state._toasts' () {
      this.toastMixin_toasts = this.toasts
    }
  }
}
